import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ground-item" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Skeleton = _resolveComponent("Skeleton")
  const _component_Source = _resolveComponent("Source")
  const _component_LifecycleEmitter = _resolveComponent("LifecycleEmitter")
  const _component_ViewMore = _resolveComponent("ViewMore")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sources-ground", {loading: $props.loading, done: $data.all_done}]),
    onScrollend: _cache[3] || (_cache[3] = $event => ($options.onScrollEnd()))
  }, [
    ($options.show_skeleton)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.colsCount, (ind) => {
          return (_openBlock(), _createBlock(_component_Skeleton, {
            key: ind,
            style: {"height":"2.8rem"}
          }))
        }), 128 /* KEYED_FRAGMENT */))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.items, (source, ind) => {
          return (_openBlock(), _createBlock(_component_LifecycleEmitter, {
            key: JSON.stringify(source),
            onMounted: _cache[1] || (_cache[1] = $event => ($props.loading && $options.onMounted()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_Source, {
                  ref_for: true,
                  ref: "source",
                  class: _normalizeClass(["src", {hidden: $data.hide_last && (ind+1 === $data.items.length)}]),
                  data: source,
                  num: ind+1,
                  disabled: $props.loading,
                  onTransitionend: _cache[0] || (_cache[0] = _withModifiers($event => ($props.loading && $options.onAppend($event)), ["stop"]))
                }, null, 8 /* PROPS */, ["data", "num", "disabled", "class"])
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */)),
    _createCommentVNode(" VIEW-MORE "),
    ($data.all_done)
      ? (_openBlock(), _createBlock(_component_ViewMore, {
          key: 2,
          class: "ground-item",
          sources: $props.sources,
          "cols-count": $props.colsCount,
          "show-all": $props.showAll,
          onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.$emit('show-all')), ["prevent"]))
        }, null, 8 /* PROPS */, ["sources", "cols-count", "show-all"]))
      : _createCommentVNode("v-if", true)
  ], 34 /* CLASS, NEED_HYDRATION */))
}